import React from 'react'
import Link from 'gatsby-link'
import resolveLink from '../../utils/resolveLink'
import Heading from '../Heading'
import Button from '../Button'
import {TextColour, HoverColour} from '../../utils/ColourUtilities'
import SubmenuAccordion from './SubmenuAccordion'

const SubmenuItem = (props) => {

    // We'll use this for the Insights Hub menu on mobile
    const collapse = props.title_1 === "" && props.title_2 === "" && props.title_3 === "" ? true : false

    return (
        <div className={`flex flex-col h-full relative ${collapse ? 'lg:mt-0 -mt-6' : 'lg:mt-0 my-11 lg:my-6'}`}>
            <div className={`${TextColour(props.accent_colour)} ${collapse ? 'lg:block hidden' : ''}`}>
                <Link to={resolveLink(`/${props.target.cached_url}`)}>
                    <Heading size="h5" className="mb-0 lg:leading-8 !text-[1.5rem]">{props.title_1}&nbsp;</Heading>
                    <Heading size="h3" className="!leading-6 mb-0 !text-[2.5rem]">{props.title_2}&nbsp;</Heading>
                    {props.title_3 && <h6 className={`font-body text-xs mt-2 pb-3 border-b border-gray-200 italic leading-6 ${props.submenu_links.length > 0 ? 'lg:block hidden' : ''}`}>{props.title_3}&nbsp;</h6>}
                </Link>
                {!props.title_3 && <hr className="border-gray-200 mt-3 lg:mb-0 mb-4"/>}
                {props.submenu_links.length > 0 && props.title_3 && <SubmenuAccordion {...props}/>}
            </div>
            <div className="lg:mt-6 flex-1">
                {props.submenu_links.length > 0 && props.submenu_links.map((item, index) => (
                    <Link to={resolveLink(`/${item.target.cached_url}`)} key={index} className={`${props.title_3 ? 'hidden lg:block' : 'block'} font-display lg:py-0 py-2 leading-3 lg:text-lg text-xl text-darkgrey ${HoverColour(props.accent_colour)} focus:outline-none outline-none duration-300`}>{item.title}</Link>
                ))}
                {props.description && <p className="prose text-xs">{props.description}</p>}
            </div>
            <div className="">
            {props.submenu_links.length < 1 && props.target.cached_url && <Button target={`/${props.target.cached_url}`} className="bg-red hover:bg-darkred mt-6 lg:text-lg text-base">{props.button_text}</Button>}
            </div>
        </div>
    )
};

export default SubmenuItem;